import { saveCampaign as UnifiedAppCampaignSave } from './campaign-bulk';

export const saveCampaign = UnifiedAppCampaignSave;
